import { cn } from "~/lib/utils";
import VideoEmbedSection from "~/components/ui/videoEmbedSection";

interface VirtualTourProps {
    className?: string;
    url: string;
    heading?: string;
    height?: number;
}

export default function VirtualTour({
    className,
    url,
    heading = "360 Tour",
    height = 500,
}: VirtualTourProps) {
    return (
        <div className={cn("space-y-2.5 md:space-y-6 w-full", className)}>
            <h3 className='text-lg md:text-2xl font-semibold text-oh-black'>{heading}</h3>
            <VideoEmbedSection height={height} url={url} />
        </div>
    );
}
